// Tipografías centralizadas
export const typography = {
  // Fuente principal
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',

  // Tamaños de fuente
  fontSize: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px',
    '4xl': '36px',
  },

  // Pesos de fuente
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },

  // Estilos específicos
  h1: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: 1.2,
    letterSpacing: '-0.025em',
  },

  h2: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: 1.3,
    letterSpacing: '-0.025em',
  },

  h3: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: 1.4,
  },

  h4: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: 1.4,
  },

  h5: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: 1.5,
  },

  h6: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: 1.5,
  },

  body1: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: 1.6,
  },

  body2: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: 1.6,
  },

  button: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: 1.5,
    textTransform: 'none' as const,
  },

  caption: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 1.5,
  },

  overline: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: 1.5,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.1em',
  },
};
